export default "__VITE_ASSET__Co2$$gVS__"